import React, { Fragment, useEffect, useState, useReducer, useContext } from 'react'
import StepWizard from 'react-step-wizard'

import AtendimentoService from '../../services/atendimento.service'

import SelecaoProcedimentos from './SelecaoProcedimentos'
import PageLoading from '../Common/PageLoading'
import Navigation from './Navigation'
import Financeiro from './Financeiro'
import Impressao from './Impressao'
import WebcamFaceDetection from '../WebcamFaceDetection'

import MenuContext from '../../contexts/MenuContexts'
import PermissoesConstants from '../../constants/permissoes.constants'
import SystemConstants from '../../constants/system.constants'
import { statusAvaliacao } from '../../constants/agendamento.constants'
import { toast } from 'react-toastify'

export default function Atendimento(props) {
  const { agendamento, history, location } = props
  const acoes = useContext(MenuContext) || []
  const acoesPermitidas = acoes.reduce((acc, a) => ({ ...acc, [a.nome]: a }), {})
  const permitirContratoManual = !!acoesPermitidas[PermissoesConstants.CONTRATO_MANUAL]
  const [tipoContrato, setTipoContrato] = useState(() => {
    if (location?.state?.pedirTipoContrato) return null
    return location?.state?.tipoContrato || 'manual'
  })

  const [isLoading, setIsLoading] = useState(true)
  const [numeroPlano, setNumeroPlano] = useState('')
  const [planoId, setPlanoId] = useState('')
  const [wizardRef, setWizardRef] = useState(null)
  const [passo, setPasso] = useState(1)
  const [avaliacao, setAvaliacao] = useState({})
  const [procedimentosSelecionados, setProcedimentosSelecionados] = useState([])
  const [modoFinalizacao, setModoFinalizacao] = useState(null)
  const [linkAssinatura, setLinkAssinatura] = useState(null)
  const [linksAssinatura, setLinksAssinatura] = useState(null)
  const [showFacial, setShowFacial] = useState(false)
  const [pagamentos, dispatchPagamento] = useReducer((pagamentos, { type, value }) => {
    const { pagamento, index } = value
    switch (type) {
      case 'add':
        return [...pagamentos, pagamento]
      case 'update':
        const atualizados = [...pagamentos]
        atualizados.splice(index, 1, pagamento)
        return atualizados
      default:
        return pagamentos
    }
  }, [])

  useEffect(() => {
    if (!agendamento.id) {
      // history.push('/agendamento')
      history.goBack()
    }
    wizardDidMount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (avaliacao.procedimentos) {
      setProcedimentosSelecionados([...avaliacao.procedimentos.filter((p) => p.efetivado)])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avaliacao.procedimentos])

  const setStepWizard = (wizard) => setWizardRef(wizard)

  const wizardDidMount = async () => {
    agendamento.id && (await getAvaliacao())
  }

  const getAvaliacao = async () => {
    const { data } = await AtendimentoService.getAvaliacaoByAgendamento(agendamento.id)
    setAvaliacao(data)
    setIsLoading(false)
  }

  const onStepChange = (passo) => setPasso(passo.activeStep)

  const renderLoading = () => <PageLoading />

  const toggleProcedimento = (procedimento, denteId, index) => {
    let procedimentos = [...avaliacao.procedimentos]
    let procedimentoIncluso = procedimentos.find((p) => p === procedimento)
    procedimentoIncluso.efetivado = !procedimentoIncluso.efetivado
    procedimentos[index] = procedimentoIncluso
    setAvaliacao({ ...avaliacao, procedimentos })
  }

  const adiarDecisaoProcedimentos = () => {
    history.goBack()
  }

  const recusarProcedimentos = async () => {
    try {
      await AtendimentoService.naoRealizarProcedimentos(avaliacao.id)
      history.goBack()
      toast('Avaliação alterada com sucesso.', { type: toast.TYPE.SUCCESS })
    } catch (e) {
      console.error(e)
    }
  }

  const setDescricao = (descricao) => setAvaliacao({ ...avaliacao, descricao })

  const setRetornoAvaliacao = (retorno) => setAvaliacao({ ...avaliacao, dataRetornoPaciente: retorno })

  const payloadAtendimento = () => {
    const user = JSON.parse(localStorage.getItem(SystemConstants.getUser()) || '{}')
    return {
      avaliacao: { ...getAvaliacaoBody(), procedimentos: procedimentosSelecionados },
      pagamentos: pagamentos.filter((pag) => !pag.avaliacaoProcedimentoProteticoId),
      pagamentosProteticos: pagamentos.filter((pag) => pag.avaliacaoProcedimentoProteticoId),
      responsavelEmpresaAssinaturaColaboradorId: user.colaboradorId || null,
    }
  }

  const gerarPlano = async () => {
    try {
      const { data } = await AtendimentoService.salvarAtendimento(payloadAtendimento())
      setNumeroPlano(data?.numeroPlano || '')
      setPlanoId(data?.id || '')
      setModoFinalizacao('tradicional')
      wizardRef.nextStep()
    } catch (error) {
      toast.error(error?.response?.data?.errors ? 'Verifique os dados.' : 'Erro ao gerar plano.')
    }
  }

  const gerarPlanoV2 = async () => {
    try {
      const { data } = await AtendimentoService.salvarAtendimentoV2(payloadAtendimento())
      if (data?.sucesso && (data?.linkAssinatura || (data?.linksAssinatura && data.linksAssinatura.length > 0))) {
        setLinkAssinatura(data.linkAssinatura || (data.linksAssinatura?.[0]?.link ?? null))
        setLinksAssinatura(data.linksAssinatura && data.linksAssinatura.length > 0 ? data.linksAssinatura : null)
        setModoFinalizacao('digital')
        wizardRef.nextStep()
        toast.success('Link(s) de assinatura gerado(s).')
      } else {
        toast.error(data?.mensagemErro || 'Não foi possível gerar o link.')
      }
    } catch (error) {
      const msg = error?.response?.data?.errors || error?.response?.data || error?.message
      toast.error(msg?.mensagemErro || (Array.isArray(msg) ? 'Verifique os dados.' : 'Erro ao gerar link de assinatura.'))
    }
  }

  const getAvaliacaoBody = () => ({
    ...avaliacao,
    statusAvaliacao: statusAvaliacao.EFETIVADA,
    dataRetornoPaciente:
      typeof avaliacao.dataRetornoPaciente === 'string'
        ? avaliacao.dataRetornoPaciente
        : avaliacao.dataRetornoPaciente.toISOString(),
  })

  const handleChangePagamento = (pagamento, index) => {
    if (!pagamentos[index]) {
      dispatchPagamento({ type: 'add', value: { pagamento, index } })
    } else {
      dispatchPagamento({ type: 'update', value: { pagamento, index } })
    }
  }

  const onFacialSucesso = () => {
    setShowFacial(false)
    gerarPlano()
  }

  const pedirTipoContrato = location?.state?.pedirTipoContrato && tipoContrato == null

  return (
    <Fragment>
      {showFacial && tipoContrato === 'manual' && (
        <WebcamFaceDetection
          pacienteId={avaliacao.pacienteId}
          dependenteId={avaliacao.dependenteId || undefined}
          cancelWebcamFaceDetection={() => setShowFacial(false)}
          closeWebcamFaceDetection={onFacialSucesso}
        />
      )}
      {pedirTipoContrato ? (
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-5">
              <div className="card shadow">
                <div className="card-body p-4 text-center">
                  <h5 className="card-title mb-3">Qual tipo de contrato deseja utilizar?</h5>
                  <p className="text-muted mb-4">Escolha o tipo de contrato para este atendimento.</p>
                  <div className="d-flex flex-column gap-2">
                    <button
                      type="button"
                      className="btn btn-primary btn-lg"
                      onClick={() => setTipoContrato('digital')}
                    >
                      Contrato Digital
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-lg"
                      disabled={!permitirContratoManual}
                      onClick={() => permitirContratoManual && setTipoContrato('manual')}
                      title={!permitirContratoManual ? 'Sem permissão para contrato manual' : undefined}
                    >
                      Contrato Manual
                      {!permitirContratoManual && (
                        <small className="d-block mt-1 text-muted">Sem permissão</small>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : isLoading ? (
        renderLoading()
      ) : (
        <Fragment>
          <StepWizard isLazyMount onStepChange={onStepChange} instance={setStepWizard}>
            <SelecaoProcedimentos
              incluirProcedimento={toggleProcedimento}
              procedimentos={avaliacao.procedimentos || []}
              descricao={avaliacao.descricao}
              setDescricao={setDescricao}
              setRetornoAvaliacao={setRetornoAvaliacao}
            />
            <Financeiro
              procedimentosSelecionados={procedimentosSelecionados}
              updatePagamento={handleChangePagamento}
              avaliacao={avaliacao}
              tipoContrato={tipoContrato}
            />
            <Impressao
              planoId={planoId}
              numeroPlano={numeroPlano}
              avaliacao={avaliacao}
              pagamentos={pagamentos}
              procedimentosSelecionados={procedimentosSelecionados}
              modoFinalizacao={modoFinalizacao}
              linkAssinatura={linkAssinatura}
              linksAssinatura={linksAssinatura}
              onReconsultarLink={() => AtendimentoService.getContratosAssinatura('Avaliacao', avaliacao.id)}
            />
          </StepWizard>
          <Navigation
            {...props}
            handleDecidirDepois={adiarDecisaoProcedimentos}
            recusarProcedimentos={recusarProcedimentos}
            finalizar={gerarPlano}
            onImprimirComFacial={() => setShowFacial(true)}
            finalizarV2={gerarPlanoV2}
            tipoContrato={tipoContrato}
            procedimentosSelecionados={procedimentosSelecionados}
            passo={passo}
            wizard={wizardRef}
            permitirContratoManual={permitirContratoManual}
            primeiraParcelaMaiorQueCinco={
              (() => {
                const pagamentoPlano = pagamentos.find((p) => !p.avaliacaoProcedimentoProteticoId)
                if (!pagamentoPlano) return false
                const v = Number(pagamentoPlano.valorPrimeiraParcelaDigitado)
                return !Number.isNaN(v) && v > 5
              })()
            }
          />
        </Fragment>
      )}
    </Fragment>
  )
}
